import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from '@mui/material';
import { QUERIES, UseResponsive } from './types';

/**
 * Hook to determine responsive screen sizes
 * @returns {Responsive} Object containing boolean flags for different screen sizes
 */
export const useResponsive = () => {
  const $ = _c(19);
  const isSmallMobileDown = useMediaQuery(QUERIES.smallMobileDown);
  const isSmallMobileUp = useMediaQuery(QUERIES.smallMobileUp);
  const isMobileDown = useMediaQuery(QUERIES.mobileDown);
  const isMobileUp = useMediaQuery(QUERIES.mobileUp);
  const isSmallTabletDown = useMediaQuery(QUERIES.smallTabletDown);
  const isSmallTabletUp = useMediaQuery(QUERIES.smallTabletUp);
  const isTabletDown = useMediaQuery(QUERIES.tabletDown);
  const isTabletUp = useMediaQuery(QUERIES.tabletUp);
  const isLargeTabletDown = useMediaQuery(QUERIES.largeTabletDown);
  const isLargeTabletUp = useMediaQuery(QUERIES.largeTabletUp);
  const isSmallDesktopDown = useMediaQuery(QUERIES.smallDesktopDown);
  const isSmallDesktopUp = useMediaQuery(QUERIES.smallDesktopUp);
  const isLargeDesktopDown = useMediaQuery(QUERIES.largeDesktopDown);
  const isLargeDesktopUp = useMediaQuery(QUERIES.largeDesktopUp);
  const isVeryLargeDesktopDown = useMediaQuery(QUERIES.veryLargeDesktopDown);
  const isVeryLargeDesktopUp = useMediaQuery(QUERIES.veryLargeDesktopUp);
  const isExtraLargeDesktopDown = useMediaQuery(QUERIES.extraLargeDesktopDown);
  const isExtraLargeDesktopUp = useMediaQuery(QUERIES.extraLargeDesktopUp);
  let t0;
  if ($[0] !== isExtraLargeDesktopDown || $[1] !== isExtraLargeDesktopUp || $[2] !== isLargeDesktopDown || $[3] !== isLargeDesktopUp || $[4] !== isLargeTabletDown || $[5] !== isLargeTabletUp || $[6] !== isMobileDown || $[7] !== isMobileUp || $[8] !== isSmallDesktopDown || $[9] !== isSmallDesktopUp || $[10] !== isSmallMobileDown || $[11] !== isSmallMobileUp || $[12] !== isSmallTabletDown || $[13] !== isSmallTabletUp || $[14] !== isTabletDown || $[15] !== isTabletUp || $[16] !== isVeryLargeDesktopDown || $[17] !== isVeryLargeDesktopUp) {
    t0 = {
      isSmallMobileDown,
      isSmallMobileUp,
      isMobileDown,
      isMobileUp,
      isSmallTabletDown,
      isSmallTabletUp,
      isTabletDown,
      isTabletUp,
      isLargeTabletDown,
      isLargeTabletUp,
      isSmallDesktopDown,
      isSmallDesktopUp,
      isLargeDesktopDown,
      isLargeDesktopUp,
      isVeryLargeDesktopDown,
      isVeryLargeDesktopUp,
      isExtraLargeDesktopDown,
      isExtraLargeDesktopUp
    };
    $[0] = isExtraLargeDesktopDown;
    $[1] = isExtraLargeDesktopUp;
    $[2] = isLargeDesktopDown;
    $[3] = isLargeDesktopUp;
    $[4] = isLargeTabletDown;
    $[5] = isLargeTabletUp;
    $[6] = isMobileDown;
    $[7] = isMobileUp;
    $[8] = isSmallDesktopDown;
    $[9] = isSmallDesktopUp;
    $[10] = isSmallMobileDown;
    $[11] = isSmallMobileUp;
    $[12] = isSmallTabletDown;
    $[13] = isSmallTabletUp;
    $[14] = isTabletDown;
    $[15] = isTabletUp;
    $[16] = isVeryLargeDesktopDown;
    $[17] = isVeryLargeDesktopUp;
    $[18] = t0;
  } else {
    t0 = $[18];
  }
  return t0;
};